import { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../Context/GlobalContext";

export const CategoryLink = ({ data }) => {
  const [categoryUrl, setCategoryUrl] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  const { getCategoryDetails } = useGlobalFunction();
  useEffect(() => {
    if (data) {
      setCategoryData(data);
      loadCategoryDetails(data);
    }
  }, [data]);

  const loadCategoryDetails = async (categoryData) => {
    var response = await getCategoryDetails({
      categoryName: categoryData,
    });
    if (response && response.url) {
      setCategoryUrl("/" + response.url);
    } else {
      setCategoryUrl("/search?q=" + categoryData);
    }
  };

  return (
    <Fragment>
      {categoryData && (
        <li>
          <Link to={categoryUrl}>
            <span className="wes-search" />
            {categoryData}
          </Link>
        </li>
      )}
    </Fragment>
  );
};
